import API from './index';

const api = {
    SubmitCtc(data) {
        return API.authAPI({
            url: '/approval/submit-ctc',
            method: 'POST',
            data,
        });
    },
    SubmitCti(data) {
        return API.authAPI({
            url: '/approval/submit-cti',
            method: 'POST',
            data,
        });
    },
    createCtcAndCti(data) {
        return API.authAPI({
            url: '/approval/create-ctc-and-cti',
            method: 'POST',
            data,
        });
    },
    saveCTCDetail({ id, data, action = 'save' }) {
        return API.authAPI({
            url: '/approval/save-ctcdetail-application/' + id,
            method: 'PATCH',
            data: {
                ctc: data,
                action,
            },
        });
    },
    saveCTIDetail({ id, data, action = 'save' }) {
        return API.authAPI({
            url: '/approval/save-ctidetail-application/' + id,
            method: 'PATCH',
            data: {
                cti: data,
                action,
            },
        });
    },
    // getCTCAndCTIFile({ id, type }) {
    //     return API.authAPI({
    //         url: '/approval/get-ctcAndctiFile',
    //         method: 'GET',
    //         params: { id, type },
    //     });
    // },
    getCTCAndCTIFile(data) {
        return API.authAPI({
            url: '/approval/get-report-detail',
            method: 'GET',
            params: { ...data },
        });
    },
    getPostApprovalDocument(data) {
        return API.authAPI({
            url: '/approval/get-post-approval-document',
            method: 'POST',
            data,
        });
    },
    getPostApprovalDocumentDetail({ type, id }) {
        return API.authAPI({
            url: `/approval/get-post-approval-document-detail/${type}/${id}`,
            method: 'GET',
        });
    },
    saveCTADetail({ id, data, action = 'save' }) {
        return API.authAPI({
            url: '/approval/save-ctadetail-application/' + id,
            method: 'PATCH',
            data: {
                cta: data,
                action,
            },
        });
    },
    downloadSignedForm({ docType, reportId }) {
        return API.authAPI({
            url: `/approval/download-signed-document/${docType}/${reportId}`,
            method: 'GET',
            responseType: 'blob',
        });
    },
    downloadDocumentZipFile({ docType, docId }) {
        return API.authAPI({
            url: `/generate/export-zip-for-post-approval/${docType}/${docId}`,
            method: 'GET',
            responseType: 'blob',
        });
    },
};

export default api;
